import { fork, takeEvery, takeLatest } from "redux-saga/effects";

import RCRMConstants from "modules/rcrm/constants";
import RCRMSagas from "modules/rcrm/sagas";
import RCRMActions from "modules/rcrm/actions";

function* watchGetLeadTarget() {
  yield takeEvery(RCRMActions.getLeadTarget, RCRMSagas.getLeadTarget);
}

function* watchSaveCRMSettingLeadForm() {
  yield takeEvery(RCRMActions.saveCRMSettingLeadForm, RCRMSagas.saveCRMSettingLeadForm);
}

function* watchSetGateItem() {
  yield takeLatest(RCRMConstants.SET_GATE_ITEM, RCRMSagas.setGateItem);
}

function* watchSaveCRMGGLeadsSetting() {
  yield takeEvery(RCRMActions.saveCRMGGLeadsSetting, RCRMSagas.saveCRMGGLeadsSetting);
}

function* watchSetCRMLoading() {
  yield takeLatest(RCRMConstants.SET_CRM_LOADING, RCRMSagas.setCRMLoading);
}

function* watchSetValidateGate() {
  yield takeLatest(RCRMConstants.SET_VALIDATE_GATE, RCRMSagas.setValidateGate);
}

export default [
  fork(watchGetLeadTarget),
  fork(watchSaveCRMSettingLeadForm),
  fork(watchSetGateItem),
  fork(watchSaveCRMGGLeadsSetting),
  fork(watchSetCRMLoading),
  fork(watchSetValidateGate),
];
